import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { ref, computed } from "vue";
import { restartAnimations } from "@/util/dom";
import { useEventListener, useTimeoutFn } from "@vueuse/core";

/** current notification text */

export default /*#__PURE__*/_defineComponent({
  __name: 'TheSnackbar',
  setup(__props) {

const text = ref("");
/** notification element */
const element = ref<Element>();

/**
 * make hide delay longer for longer messages
 * https://ux.stackexchange.com/questions/22520/how-long-does-it-take-to-read-x-number-of-characters
 */
const delay = computed(() => 1500 + text.value.length * 100);
/** timer */
const { start, stop } = useTimeoutFn(() => (text.value = ""), delay);

/** on push notification event */
function onPush(event: Event) {
  /** flash notification */
  if (element.value) restartAnimations(element.value);

  /** set notification text */
  text.value = (event as CustomEvent).detail;

  /** set timer to close */
  start();
}

/** when user clicks notification */
function onClick() {
  stop();
  text.value = "";
}

/** listen for push notification event */
useEventListener(window, "snackbar", onPush);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (text.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "element",
              ref: element,
              role: "alert",
              "aria-live": "polite",
              class: "snackbar",
              onClick: onClick,
              onKeydown: _cache[0] || (_cache[0] = () => null)
            }, _toDisplayString(text.value), 545))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})